<template>
  <div>
    <el-submenu v-if="item.children && item.children.length" :index="item.component">
      <template slot="title">
        <i v-if="item.icon" :class="item.icon"></i>
        <span slot="title">{{item.title}}</span>
      </template>
      <subItem
        v-for="v in item.children"
        :key="v.id"
        :item="v"
      />
    </el-submenu>
    <el-menu-item v-else :index="item.component" @click="clickSub(item)">
      <i v-if="item.icon" :class="item.icon"></i>
      <span slot="title">{{item.title}}</span>
    </el-menu-item>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'subItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  methods: {
    clickSub (e) {
      const isContained = this.$beard.some(obj => obj.component === e.component)
      // 不包含的情况下添加新标签进去
      // 用户选择的所有标签栏
      if (!isContained) {
        this.$beard.push({
          id: e.id,
          icon: e.icon,
          component: e.component,
          title: e.title
        })
      } else {
        
      }
      // 当前选中的标签栏
      // new Vue().$emit('nowSelect', e.path)
      this.$selectBeard.splice(0, 1, e.component)
    }
  }
}
</script>
